import { call, put } from 'redux-saga/effects'
import { toast } from 'react-toastify'
import {setPrescriptionInfo, setPrescription, setLoading, setError, setProcessing, setUpdatedOrder, removeOrderFromList,setLoader, setAddress, setNewPrescription} from 'redux/slices/prescriptionSlice'
import {requestViberPrescription, requestUpdateName, requestCreateOrder, requestScannedOrder, requestPharmacyPrescription, requestCreatePrescription, requestDeletePrescription, requestSendQuotation, requestConfirmOrder, requestCancelOrder, requestUpdateAddress} from '../requests/prescriptionService'
import {requestNewAddress} from '../requests/nurseCampaignService'
import {removePrescriptionFromList} from 'redux/slices/prescriptionSlice'
import {setResetPage} from 'redux/slices/prescriptionSlice'
import { setAppLoading } from 'redux/slices/authTokenSlice'

export function* handleViberPrescriptionGet(action) {
  try {
    yield put(setLoading())
    const response = yield call(() => requestViberPrescription(action.payload))
    yield put(setPrescription(response.data))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    yield put(setError({ error: errorMsg }))
  }
}

export function* handleUpdateName(action) {
  try {
    yield put(setProcessing())
    const response = yield call(() => requestUpdateName(action.payload))
    yield put(setUpdatedOrder(response.data))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(errorMsg)
  }finally{
    yield put(setProcessing(false))
  }
}

export function* handleCreateOrder(action) {
  try {
    yield put(setProcessing())
    yield call(() => requestCreateOrder(action.payload))
    yield put(removeOrderFromList(action.payload))
    toast.success("Order created successfully")
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(errorMsg)
  }finally{
    yield put(setProcessing(false))
  }
}

export function* handleScannedPrescriptionGet(action) {
  try {
    yield put(setLoading())
    const response = yield call(() => requestScannedOrder(action.payload))
    yield put(setPrescription(response.data))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    yield put(setError({ error: errorMsg }))
  }
}

export function* handlePrescriptionInfoGet(action) {
  try {
    yield put(setLoading())
    const response = yield call(() => requestPharmacyPrescription(action.payload))
    yield put(setPrescriptionInfo(response.data))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    yield put(setError({ error: errorMsg }))
  }
}

export function* handleCreatePrescription(action) {
  try {
    yield put(setProcessing())
    const response = yield call(() => requestCreatePrescription(action.payload))
    yield put(setNewPrescription(response.data))
    toast.success("Prescription Created");
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(errorMsg)
  }finally{
    yield put(setProcessing(false));
  }
}

export function* handleNewAddAddress(action){
  try {
    const {userId, address} = action.payload;
    yield put(setLoader(true))
    const response = yield call(() => requestNewAddress(userId, address))
    yield put(setAddress(response.data))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(errorMsg)
  } finally {
    yield put(setLoader(false))
  }
}

export function* handleDeletePrescription(action){
  try {
    yield put(setProcessing(true))
    yield call(() => requestDeletePrescription(action.payload))
    yield put(removePrescriptionFromList(action.payload))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(errorMsg)
  } finally {
    yield put(setProcessing(false))
  }
}

export function* handleSendQuotation(action) {
  try {
    yield put(setAppLoading())
    yield call(() => requestSendQuotation(action.payload))
    yield put(setResetPage(true))
    toast.success("Quotation Sent")
  } catch (e) {
    const errormsg = e.response ? e.response.data.message : e.message
    toast.error(errormsg)
  } finally {
    yield put(setAppLoading(false))
  }
}

export function* handleConfirmOrder(action) {
  try {
    yield put(setAppLoading())
    yield call(() => requestConfirmOrder(action.payload))
    yield put(setResetPage(true))
    toast.success("Order Confirmed")
  } catch (e) {
    const errormsg = e.response ? e.response.data.message : e.message
    toast.error(errormsg)
  } finally {
    yield put(setAppLoading(false))
  }
}

export function* handleCancelOrder(action) {
  try {
    yield put(setProcessing(true))
    yield call(() => requestCancelOrder(action.payload))
    yield put(removeOrderFromList(action.payload))
    toast.success("Order Cancelled")
  } catch (e) {
    const errormsg = e.response ? e.response.data.message : e.message
    toast.error(errormsg)
  } finally {
    yield put(setProcessing(false))
  }
}


export function* handleUpdateAddress(action) {
  try {
    yield put(setProcessing(true))
    const {data} = yield call(() => requestUpdateAddress(action.payload))
    yield put(setAddress(data))
    toast.success("Address Updated")
  } catch (e) {
    const errormsg = e.response ? e.response.data.message : e.message
    toast.error(errormsg)
  } finally {
    yield put(setProcessing(false))
  }
}
